import { createContext, useContext, useState, useEffect } from "react";
import { authAPI } from "../utils/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = sessionStorage.getItem("token");
        if (token) {
            authAPI.getCurrentUser()
                .then((res) => setUser(res.data.user))
                .catch(() => {
                    sessionStorage.removeItem("token");
                    setUser(null);
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (credentials) => {
        const res = await authAPI.login(credentials);
        sessionStorage.setItem("token", res.data.token);
        setUser(res.data.user);
        return res;
    };

    const register = async (userData) => {
        const res = await authAPI.register(userData);
        sessionStorage.setItem("token", res.data.token);
        setUser(res.data.user);
        return res;
    };

    const logout = async () => {
        try {
            await authAPI.logout();
        } catch (e) {
            // clear local state regardless
        }
        sessionStorage.removeItem("token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);